import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetLead as GetLeadQuery,
    GetLeadVariables as GetLeadVariables,
    GetLead_lead as Lead,
} from 'nutshell-graphql-types';

import GET_LEAD from '../queries/get-lead.graphql';

export const useGetLead = (
    id?: string | null,
    number?: number | null,
    skip: boolean = false
): {
    lead: Lead | null | undefined;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<GetLeadQuery, GetLeadVariables>(GET_LEAD, {
        variables: {
            id,
            number,
        },
        fetchPolicy: 'cache-and-network',
        skip,
    });

    return {
        lead: data && data.lead,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
